import {useDispatch, useSelector} from "react-redux";
import {resetTicketFilterPaginationOnSolvedClosedToggleChange, setTicketsFiltered} from "@pages/tickets/store/tickets.slice";
import {getList} from "@pages/tickets/services/tickets.service";
import { TicketStatuses } from "../models/ticket.status.enum";
import {selectIsTicketsFiltered, selectTicketFilter, selectTicketsPaging } from "../store/tickets.selectors";

export const useTicketHandler = () => {
    const dispatch = useDispatch();
    const currentFilter = useSelector(selectTicketFilter);
    const currentPagination = useSelector(selectTicketsPaging);
    const areTicketsFiltered = useSelector(selectIsTicketsFiltered);
    
     const fetchAllTickets = () =>
    {
        dispatch(resetTicketFilterPaginationOnSolvedClosedToggleChange());
        dispatch(getList({
            ...currentFilter,
            ...currentPagination,
            statuses: []
            }, true));
        dispatch(setTicketsFiltered(areTicketsFiltered));
    }

    const fetchActiveTickets = () => {
        dispatch(resetTicketFilterPaginationOnSolvedClosedToggleChange());
        dispatch(getList({
            ...currentFilter,
            ...currentPagination,
            statuses: [TicketStatuses.Open, TicketStatuses.InProgress, TicketStatuses.OnHold]
            }, true));
            dispatch(setTicketsFiltered(true));
    }

    const fetchClosedAndSolvedTickets = () => {
        dispatch(resetTicketFilterPaginationOnSolvedClosedToggleChange());
        dispatch(getList({
            ...currentFilter,
            ...currentPagination,
            statuses: [TicketStatuses.Solved, TicketStatuses.Closed]
        }, true));
        dispatch(setTicketsFiltered(true));
    }
    
    return { fetchActiveTickets, fetchAllTickets, fetchClosedAndSolvedTickets }
}